/* istanbul ignore file */
import React, {ReactNode, createContext, useContext} from 'react';

import {assertIsNotNullish} from '@br/idm-components';
import {WEXEnvironments} from '@br/mg-components';

import {safeLoadJson} from '../utils/data';

type SettingsType = {
    POLICY_ENABLED: boolean;
    HPWOLF_SUPPORT_URL: string;
    APP_SWITCHER_ENABLED: boolean;
    WEX_ENVIRONMENT: WEXEnvironments;
    SUPPORT_USER_DOMAINS: string[];
    PROVISIONAL_LICENSE_GENERATION_ENABLED: boolean;
};

const SettingsContext = createContext<SettingsType>({} as SettingsType);

const SettingsContextProvider = ({children}: {children: ReactNode}): JSX.Element => {
    const settings = safeLoadJson<SettingsType>('#settings');

    assertIsNotNullish(settings);
    return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

const useSettings = () => useContext(SettingsContext);

export {SettingsContextProvider, SettingsType, SettingsContext, useSettings};
